export enum SlidesActions {
  SIGNUP = 'signup',
  SIGNUP_ACADEMY = 'academy',
  SIGNUP_FAMILY = 'family',
  FORGOT = 'forgot',
  LOGIN = 'login',
}
